// @flow
import jwt from '../../utils/jwt'

/**
 * Returns user id of authorized user from JWT token if exists.
 * Otherwise returns null;
 * @private
 * @return {?number} user id or null
 */
export const getAuthorizedUserId = (): ?number => jwt.getAuthorizedUserId()

export default getAuthorizedUserId
